import React from 'react';
import { useEscape } from '../../hooks/useEscape';

const cx = (...parts) => parts.filter(Boolean).join(' ');
const stop = e => e.stopPropagation();

/**
 * The one dialog shell: dimmed backdrop, Esc to close, dialog aria. A press on the
 * backdrop calls `onBackdrop` (default: close) — a sheet with unsaved choices passes
 * its own so a stray tap doesn't throw them away.
 */
export function Modal({ label, onClose, onBackdrop = onClose, className, backdropClassName, style, backdropProps, children }) {
  useEscape(onClose);
  return (
    <div className={cx('do-modal-back', backdropClassName)} onMouseDown={onBackdrop} {...backdropProps}>
      <div className={cx('do-modal', className)} role="dialog" aria-modal="true" aria-label={label}
        style={style} onMouseDown={stop}>
        {children}
      </div>
    </div>
  );
}
